export const RESELLER_SERVICE_PERMANENT_FEATURE_LISTS = ['Mail Only', 'default', 'disabled']

export const RESELLER_SERVICE_DEFAULT_FEATURE_LIST = 'default'
export const RESELLER_SERVICE_DEFAULT_THEME = 'jupiter'
export const RESELLER_SERVICE_DEFAULT_MAIL_ROUTING = 'local'
export const RESELLER_SERVICE_PRIVILEGE_PACKAGE_MANAGEMENT = 'list-pkgs'
export const RESELLER_SERVICE_PRIVILEGE_PACKAGE_ADD = 'add-pkg'
export const RESELLER_SERVICE_PRIVILEGE_DNS_EDIT = 'edit-dns'
export const RESELLER_SERVICE_PRIVILEGE_SHELL_ALLOW = 'allow-shell'

export const SERVICE_TYPES = {
  CPANEL: 'cpanel',
  RESELLER: 'whm',
  VPS: 'vserver',
  DEDICATED: 'dserver',
  KVM: 'kvm',
  OTHER: 'other',
}

export const SERVICE_STATUSES = {
  SUSPENDED: 'Suspended',
}

export const SERVICE_BILLING_PERIODS = {
  MONTHLY: 'Monthly',
  QUARTERLY: 'Quarterly',
  SEMIANNUALLY: 'Semiannually',
  ANNUALLY: 'Annually',
  BIENNIALLY: 'Biennially',
  TRIENNIALLY: 'Triennially',
}

export const SERVICE_ROUTE_TYPE_BY_SERVICE_TYPE = {
  CPANEL: 'shared',
  RESELLER: 'reseller',
  VPS: 'vps',
  DEDICATED: 'dedicated',
  KVM: 'kvm',
}
